import { render, staticRenderFns } from "./push-configuration.vue?vue&type=template&id=89d9e45c&scoped=true"
import script from "./push-configuration.vue?vue&type=script&lang=js"
export * from "./push-configuration.vue?vue&type=script&lang=js"
import style0 from "./push-configuration.vue?vue&type=style&index=0&id=89d9e45c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89d9e45c",
  null
  
)

export default component.exports